import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["loadingType", "indeterminate", "compact", "className", "style", "loadingId", "linearWidth", "stopPercent", "circularWidth"];
import * as React from 'react';
import ClassNames from 'classnames';
import { mergeRefs } from '../utils';
var Loading = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _props$loadingType = props.loadingType,
    loadingType = _props$loadingType === void 0 ? 'linear' : _props$loadingType,
    _props$indeterminate = props.indeterminate,
    indeterminate = _props$indeterminate === void 0 ? false : _props$indeterminate,
    _props$compact = props.compact,
    compact = _props$compact === void 0 ? false : _props$compact,
    className = props.className,
    style = props.style,
    loadingId = props.loadingId,
    _props$linearWidth = props.linearWidth,
    linearWidth = _props$linearWidth === void 0 ? '148px' : _props$linearWidth,
    _props$stopPercent = props.stopPercent,
    stopPercent = _props$stopPercent === void 0 ? 75 : _props$stopPercent,
    _props$circularWidth = props.circularWidth,
    circularWidth = _props$circularWidth === void 0 ? "24px" : _props$circularWidth,
    restProps = _objectWithoutPropertiesLoose(props, _excluded);
  if (typeof linearWidth === 'number') linearWidth = linearWidth + 'px';
  if (typeof circularWidth === 'number') circularWidth = circularWidth + 'px';
  var _React$useState = React.useState(false),
    animation = _React$useState[0],
    setAnimation = _React$useState[1];
  var loadingRef = React.useRef();
  React.useEffect(function () {
    if (loadingType === 'linear') {
      loadingRef.current.style.width = linearWidth;
      var progress = linearWidth;
      if (typeof linearWidth === 'string' && stopPercent <= 100) {
        progress = Number(linearWidth.replace(/px(\S*)/, '')) * stopPercent / 100 + 'px';
      }
      loadingRef.current.style.setProperty("--linearLoadingWidth", progress);
      loadingRef.current.style.setProperty("--containerWidth", linearWidth);
    }
    if (loadingType === 'circular') {
      var calcDeg = stopPercent * 1.8 + 'deg';
      var circleNode = loadingRef.current.childNodes[0];
      var oneBar = circleNode.querySelector('.ap-circular-full');
      oneBar.style.transform = "rotate(" + calcDeg + ")";
      var secBar = circleNode.querySelectorAll('.progress-bar');
      secBar[0].style.transform = "rotate(" + calcDeg + ")";
      secBar[1].style.transform = "rotate(" + calcDeg + ")";
      var DefValue = typeof circularWidth === 'string' ? parseInt(circularWidth.split('px')[0]) : circularWidth;
      var compactValue = DefValue / 1.5 + 'px';
      loadingRef.current.style.setProperty("--rotateDegree", calcDeg);
      loadingRef.current.style.setProperty("--circularLoadingWidth", circularWidth);
      loadingRef.current.style.setProperty("--circularLoadingCompactWidth", compactValue);
    }
    startStopAnimation();
  }, [stopPercent]);
  var startStopAnimation = function startStopAnimation() {
    setAnimation(true);
  };
  var loadingClasses = ClassNames("ap-loading", className);
  var linearClasses = ClassNames("ap-loading-linear", {
    'bounces': indeterminate && animation,
    'compact': compact
  });
  var circularClasses = ClassNames("ap-loading-circular", {
    'animation': indeterminate,
    'compact': compact,
    'loading': animation
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    id: loadingId,
    ref: mergeRefs(ref, loadingRef),
    className: loadingClasses,
    style: style
  }, restProps), loadingType === 'linear' && /*#__PURE__*/React.createElement("div", {
    className: linearClasses
  }, /*#__PURE__*/React.createElement("div", {
    className: "linear-bar-inner"
  }), /*#__PURE__*/React.createElement("div", {
    className: "linear-bar-bg"
  })), loadingType === 'circular' && /*#__PURE__*/React.createElement("div", {
    className: circularClasses
  }, /*#__PURE__*/React.createElement("div", {
    className: "circle"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mask ap-circular-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "progress-bar"
  })), /*#__PURE__*/React.createElement("div", {
    className: "mask ap-circular-half"
  }, /*#__PURE__*/React.createElement("div", {
    className: "progress-bar"
  })), /*#__PURE__*/React.createElement("div", {
    className: "inside-circle"
  }))));
});
export default Loading;